import { render, staticRenderFns } from "./WikiMemberList.vue?vue&type=template&id=25fdcef6"
import script from "./WikiMemberList.vue?vue&type=script&lang=ts"
export * from "./WikiMemberList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports